import Sortable from 'sortablejs';
import ApplicationController from '../editor/application_controller';
import { createRequest } from '../helpers/createRequest';

export default class extends ApplicationController {
  static values = { 
    sectionId: Number,
    studioId: Number 
  }

  connect() {
    console.log('[X1 Activities] Controller connected');
    console.log('[X1 Activities] Section ID:', this.sectionIdValue);
    console.log('[X1 Activities] Studio ID:', this.studioIdValue);
    console.log('[X1 Activities] Current element:', this.element);
    console.log('[X1 Activities] HTML of element:', this.element.outerHTML.substring(0, 200));
    this.initializeActivitiesSorting();
  }

  initializeActivitiesSorting() {
    const activitiesGrid = this.element.querySelector('.activities-grid');
    
    console.log('[X1 Activities] Looking for activities-grid element');
    console.log('[X1 Activities] Found element:', activitiesGrid);
    
    if (activitiesGrid) {
      const activityCards = activitiesGrid.querySelectorAll('.activity-card');
      console.log('[X1 Activities] Found', activityCards.length, 'activity cards:', activityCards);
      
      console.log('[X1 Activities] Creating Sortable instance');
      const sortableInstance = new Sortable(activitiesGrid, {
        animation: 150,
        handle: '.activity-card', // Handle for dragging
        filter: '.new-activity-card', // Don't allow dragging the "New Activity" card
        preventOnFilter: false,
        ghostClass: 'sortable-ghost',
        dragClass: 'sortable-drag',
        chosenClass: 'sortable-chosen',
        onStart: (evt) => {
          console.log('[X1 Activities] Drag started');
          console.log('[X1 Activities] Dragged item:', evt.item);
          console.log('[X1 Activities] Is new activity card?', evt.item.classList.contains('new-activity-card'));
        },
        onEnd: (evt) => {
          console.log('[X1 Activities] Drag ended');
          console.log('[X1 Activities] Item:', evt.item);
          console.log('[X1 Activities] From index:', evt.oldIndex, 'To index:', evt.newIndex);
          
          // Don't process if the new activity card was involved
          if (evt.item.classList.contains('new-activity-card')) {
            console.log('[X1 Activities] Skipping update - new activity card');
            return;
          }
          this.updateActivityPositions(evt);
        },
        onFilter: (evt) => {
          console.log('[X1 Activities] Filtered element clicked:', evt.item);
        }
      });
      
      console.log('[X1 Activities] Sortable instance created:', sortableInstance);
    } else {
      console.error('[X1 Activities] Could not find activities-grid element!');
    }
  }

  updateActivityPositions(evt) {
    console.log('[X1 Activities] Updating activity positions');
    const activitiesGrid = evt.target;
    const sortedActivities = activitiesGrid.querySelectorAll('.activity-card:not(.new-activity-card)');
    
    console.log('[X1 Activities] Found sorted activities:', sortedActivities.length);
    
    const positions = [...sortedActivities].map((el, index) => {
      const id = el.dataset.activityId;
      const position = { id, position: index + 1 };
      console.log('[X1 Activities] Position mapping:', position);
      return position;
    });

    console.log('[X1 Activities] Sending positions to server:', positions);

    fetch(createRequest('/x1/assignments/positions', 'POST', JSON.stringify(positions)))
      .then(response => {
        console.log('[X1 Activities] Server response status:', response.status);
        if (response.ok) {
          console.log('[X1 Activities] Activity order updated successfully');
        } else {
          console.error('[X1 Activities] Server returned error:', response.status);
        }
        return response.text();
      })
      .then(text => {
        if (text) {
          console.log('[X1 Activities] Server response body:', text);
        }
      })
      .catch(error => {
        console.error('[X1 Activities] Error updating activity positions:', error);
        console.error('[X1 Activities] Error details:', error.message, error.stack);
        // Revert the visual change if the save fails
        location.reload();
      });
  }
}